import { Grid, MenuItem } from '@mui/material';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { onFormatPhoneChange, onPostalCodeChange } from '../../FieldFormat';
import { AddressInput, AddressSelect } from './AddressInput';

const AddressInfo = (props: { formik: any }): JSX.Element => {
  const { t } = useTranslation('component');
  const Provinces = [
    { ProvinceName: t('Province.AB'), ProvinceCode: 'AB' },
    { ProvinceName: t('Province.BC'), ProvinceCode: 'BC' },
    { ProvinceName: t('Province.MB'), ProvinceCode: 'MB' },
    { ProvinceName: t('Province.NB'), ProvinceCode: 'NB' },
    { ProvinceName: t('Province.NL'), ProvinceCode: 'NL' },
    { ProvinceName: t('Province.NT'), ProvinceCode: 'NT' },
    { ProvinceName: t('Province.NS'), ProvinceCode: 'NS' },
    { ProvinceName: t('Province.NU'), ProvinceCode: 'NU' },
    { ProvinceName: t('Province.ON'), ProvinceCode: 'ON' },
    { ProvinceName: t('Province.PE'), ProvinceCode: 'PE' },
    { ProvinceName: t('Province.QC'), ProvinceCode: 'QC' },
    { ProvinceName: t('Province.SK'), ProvinceCode: 'SK' },
    { ProvinceName: t('Province.YT'), ProvinceCode: 'YT' },
  ];

  return (
    <>
      <Grid item xs={12}>
        <AddressInput
          fullWidth
          id="AddressLabelInput"
          name="AddressLabel"
          defaultValue={props.formik.values.AddressLabel}
          onChange={props.formik.handleChange}
          error={props.formik.touched.AddressLabel && Boolean(props.formik.errors.AddressLabel)}
          helperText={props.formik.touched.AddressLabel && props.formik.errors.AddressLabel}
          label={t('Form.AddressLabel') + ' ' + t('Form.Optional')}
        />
      </Grid>

      <Grid item xs={12}>
        <AddressInput
          fullWidth
          id="AddressFirstNameInput"
          name="AddressFirstName"
          defaultValue={props.formik.values.AddressFirstName}
          onChange={props.formik.handleChange}
          error={props.formik.touched.AddressFirstName && Boolean(props.formik.errors.AddressFirstName)}
          helperText={props.formik.touched.AddressFirstName && props.formik.errors.AddressFirstName}
          label={t('Form.FirstName')}
        />
      </Grid>

      <Grid item xs={12}>
        <AddressInput
          fullWidth
          id="AddressLastNameInput"
          name="AddressLastName"
          defaultValue={props.formik.values.AddressLastName}
          onChange={props.formik.handleChange}
          error={props.formik.touched.AddressLastName && Boolean(props.formik.errors.AddressLastName)}
          helperText={props.formik.touched.AddressLastName && props.formik.errors.AddressLastName}
          label={t('Form.LastName')}
        />
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <AddressInput
              fullWidth
              id="CivicNumberInput"
              name="CivicNumber"
              defaultValue={props.formik.values.CivicNumber}
              onChange={props.formik.handleChange}
              error={props.formik.touched.CivicNumber && Boolean(props.formik.errors.CivicNumber)}
              helperText={props.formik.touched.CivicNumber && props.formik.errors.CivicNumber}
              label={t('Form.CivicNumber')}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <AddressInput
              fullWidth
              id="StreetInput"
              name="Street"
              defaultValue={props.formik.values.Street}
              onChange={props.formik.handleChange}
              error={props.formik.touched.Street && Boolean(props.formik.errors.Street)}
              helperText={props.formik.touched.Street && props.formik.errors.Street}
              label={t('Form.Street')}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <AddressInput
          fullWidth
          id="ApartmentInput"
          name="Apartment"
          defaultValue={props.formik.values.Apartment}
          onChange={props.formik.handleChange}
          error={props.formik.touched.Apartment && Boolean(props.formik.errors.Apartment)}
          helperText={props.formik.touched.Apartment && props.formik.errors.Apartment}
          label={t('Form.Apartment') + ' ' + t('Form.Optional')}
        />
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <AddressInput
              fullWidth
              id="CityInput"
              name="City"
              defaultValue={props.formik.values.City}
              onChange={props.formik.handleChange}
              error={props.formik.touched.City && Boolean(props.formik.errors.City)}
              helperText={props.formik.touched.City && props.formik.errors.City}
              label={t('Form.City')}
            />
          </Grid>

          <Grid item xs={6}>
            <AddressSelect
              id="ProvinceDropdown"
              name="Province"
              onChange={props.formik.handleChange}
              defaultValue={props.formik.initialValues.Province}
              label={t('Form.Province')}
              error={props.formik.touched.Province && Boolean(props.formik.errors.Province)}
              helperText={props.formik.touched.Province && props.formik.errors.Province}
              helperTextId="ProvinceErrorText"
              variant="standard"
              style={{
                color:
                  props.formik.values.Province == 'default'
                    ? //Si la valeur est le Selectionner on valide qu'il n'y a pas d'erreur sinon on le set gris pale du figma
                      props.formik.touched.Province && Boolean(props.formik.errors.Province)
                      ? '#f44336'
                      : '#5D7181'
                    : //Sinon on laisse les champs noir comme normalement
                      'Black',
              }}>
              <MenuItem sx={{ display: 'none' }} value={'default'}>
                {t('Form.Select')}
              </MenuItem>
              {Provinces.map((data: { ProvinceName: string; ProvinceCode: string }) => {
                return (
                  <MenuItem key={data.ProvinceCode} value={data.ProvinceCode}>
                    {data.ProvinceName}
                  </MenuItem>
                );
              })}
            </AddressSelect>
          </Grid>

          <Grid item xs={6}>
            <AddressInput
              fullWidth
              id="PostalCodeInput"
              name="PostalCode"
              defaultValue={props.formik.values.PostalCode}
              onChange={(event: ChangeEvent<HTMLInputElement>) => onPostalCodeChange(event, props.formik.handleChange)}
              error={props.formik.touched.PostalCode && Boolean(props.formik.errors.PostalCode)}
              helperText={props.formik.touched.PostalCode && props.formik.errors.PostalCode}
              label={t('Form.PostalCode')}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <AddressInput
              fullWidth
              disabled={true}
              id="CountryInput"
              name="Country"
              defaultValue={props.formik.values.Country}
              onChange={props.formik.handleChange}
              error={props.formik.touched.Country && Boolean(props.formik.errors.Country)}
              helperText={props.formik.touched.Country && props.formik.errors.Country}
              label={t('Form.Country')}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <AddressInput
          fullWidth
          id="AddressPhoneNumberInput"
          name="AddressPhoneNumber"
          defaultValue={props.formik.values.AddressPhoneNumber}
          onChange={(event) => onFormatPhoneChange(event, props.formik.handleChange)}
          error={props.formik.touched.AddressPhoneNumber && Boolean(props.formik.errors.AddressPhoneNumber)}
          helperText={props.formik.touched.AddressPhoneNumber && props.formik.errors.AddressPhoneNumber}
          label={t('Form.PhoneNumber')}
        />
      </Grid>
    </>
  );
};

export default AddressInfo;
